import angular from 'angular';

const dependencies = ['Sq.Core', 'Sq.AppConstants', 'Sq.TrendData', 'Sq.Worksheet'];

/**
 * @module The Annotation module provides the annotations directive
 */
angular.module('Sq.Annotation', dependencies);
